import React, {Component} from 'react';
import classNames from 'classnames';

import styles from './PseudoLinkBox.less';

const {
	'pseudo-link-box': pseudoLinkBoxClass,
	'pseudo-link-box__inner': innerClass,
	'pseudo-link-box__inner--dashed': dashedClass,
} = styles;

export default class PseudoLinkBox extends Component {
	render() {
		const {children, className, ...props} = this.props;

		return (
			<span className={classNames(className, pseudoLinkBoxClass)} {...props}>{children}</span>
		);
	}
}

export class PseudoLinkBoxInner extends Component {
	render() {
		const {children, dashed, className, ...props} = this.props;

		return (
			<span className={classNames(className, innerClass, {[dashedClass]: dashed})} {...props}>{children}</span>
		);
	}
}